import React, { useEffect, useState } from "react";
import PropTypes from "prop-types"
import styles from "./InformativeModal.module.css";

export const variantImages = {
  success: '/images/svgicon/promptSuccess.svg',
  error: '/images/svgicon/decline.svg',
  warning: '/images/svgicon/warning.svg',
}

export const VARIANTS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
}

const InformativeModalLight = ({ isOpen, onClose, variant, message }) => {
  const [isModalOpen, setIsModalOpen] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setIsModalOpen(true);
      setTimeout(() => {
        setIsModalOpen(false);
        onClose();
      }, 2000);
    }
  }, [isOpen, onClose]);

  const handleModalClose = () => {
    setIsModalOpen(false)
    onClose()
  }

  if (!isModalOpen) {
    return null;
  }

  return (
    <div className={`${styles.modalContainer} ${styles.lightModalContainer}`}>
      <div className={`${styles.modalWrapper}`}>
          <div className={`${styles.modalCloseWrapper}`}>
            <img
                className={`${styles.lightThemeModalCrossIcon}`}
                onClick={handleModalClose}
                src='/images/geofenceModuleIcon/closeBtn.svg'
                alt='close-btn'
            />
        </div>
        <div className={`${styles.content}`}>
          <img className={styles.statusIcon} src={variantImages[variant]} alt={variant} />
          <div className={styles.message}>{message}</div>
        </div>
      </div>
    </div>
  );
};

InformativeModalLight.defaultProps = {
  isOpen: false,
  onClose: () => { },
  variant: 'success',
  message: 'Success',
};

InformativeModalLight.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['success, error, warning']),
  message: PropTypes.string,
};

export default InformativeModalLight; 